module.exports = __webpack_public_path__ + "static/img/logoy.b706122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoy.png
// module id = QGGT
// module chunks = 1